import { render, staticRenderFns } from "./ArticleSell.vue?vue&type=template&id=fa07b70a&scoped=true"
import script from "./ArticleSell.vue?vue&type=script&lang=js"
export * from "./ArticleSell.vue?vue&type=script&lang=js"
import style0 from "./ArticleSell.vue?vue&type=style&index=0&id=fa07b70a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa07b70a",
  null
  
)

export default component.exports